<template>
    <v-card style="background-color: transparent" elevation="0">
        <v-card-title
            :class="
                !$vuetify.display.mobile
                    ? 'title font-weight-regular justify-space-between'
                    : 'title font-weight-regular pa-1'
            "
            v-if="documentType !== 'BANK_STATEMENT'"
        >
            {{ title }}
        </v-card-title>
        <v-window v-model="wizardStep" touchless style="min-height: 27vh">
            <v-window-item :value="2">
                <v-card-text class="py-0 px-4">
                    <SelectUser
                        v-bind:companyId="companyId"
                        v-model="owner"
                        v-if="wizardStep === 2 && companyId"
                    >
                    </SelectUser>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="3">
                <v-card-text class="py-0 px-4">
                    <v-row>
                        <v-col v-if="documentType === 'MISCELLANEOUS'">
                            <oss-date-picker-filled
                                v-model="date"
                                :textFieldReadOnly="false"
                                label="Date du document"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            v-if="
                                selectedCompany &&
                                freeTag &&
                                !documentId &&
                                this.workingDocumentType !== 'EXPENSE_REPORT_DOCUMENT'
                            "
                        >
                            <FreeTag
                                :documentType="documentType"
                                :company="selectedCompany"
                                :companyTags="allCompanyTags"
                                :splitUserPartitions="true"
                                @updateTags="onTags($event)"
                            />
                        </v-col>
                        <v-col cols="12" v-if="drop">
                            <label for="file" class="cursor-pointer">
                                <DropZone @files-dropped="onDropFile">
                                    <v-row
                                        no-gutters
                                        class="d-flex align-center rounded-lg py-5 dashed"
                                    >
                                        <v-col cols="12" class="d-flex justify-center pb-4">
                                            <v-icon size="40">$add</v-icon>
                                        </v-col>
                                        <v-col cols="12" class="d-flex justify-center headline">
                                            {{
                                                multiple
                                                    ? $t("documentUpload.dropFiles")
                                                    : $t("documentUpload.dropFile")
                                            }}
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="d-flex justify-center"
                                            v-if="
                                                ![
                                                    'BANK_STATEMENT',
                                                    'COMPANIES',
                                                    'INVOICE_PRODUCTS',
                                                    'STOCK_PRODUCTS',
                                                    'FIXED_ASSETS',
                                                    'EXPORT_OFFICE',
                                                    'ACCOUNTING_PLAN',
                                                ].includes(documentType)
                                            "
                                        >
                                            {{ $t("documentUpload.advice") }}
                                        </v-col>
                                        <v-col cols="12" class="d-flex justify-center">
                                            {{ acceptedFileTypesWording }}
                                        </v-col>
                                    </v-row>
                                </DropZone>
                            </label>
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col :cols="fileUploadColSize" class="mb-0 pb-0">
                                    <v-btn
                                        block
                                        color="ternary"
                                        variant="tonal"
                                        class="rounded-lg elevation-0"
                                        size="large"
                                        data-cy="UploadDocuments-ManualUploadButton-OpenDialog"
                                    >
                                        <label
                                            for="file"
                                            class="cursor-pointer d-flex justify-center align-center w-100 h-100 position-absolute"
                                        >
                                            <v-icon icon="$attach_file" class="mr-2" />
                                            Cet appareil
                                        </label>
                                    </v-btn>
                                </v-col>
                                <v-col
                                    :cols="localDBox ? 4 : 6"
                                    class="mb-0 pb-0"
                                    v-if="localGDrive"
                                >
                                    <DropZoneGoogleDrive
                                        :clientId="'622820122137-f84p9l7u89ie8qk6ib1qa3ef7cga12nr.apps.googleusercontent.com'"
                                        :developerKey="'AIzaSyCixCzLyhvavUjPS6EBocE4iYOXvm8dmMk'"
                                        :scope="['https://www.googleapis.com/auth/drive.readonly']"
                                        @change="onGoogleDriveFilesSelected"
                                        @authenticated="onAuthenticated"
                                        :multiselect="multiple"
                                        :navHidden="false"
                                        :authImmediate="false"
                                        :upload="false"
                                        :mimeTypes="mimeTypes"
                                        :viewId="'FOLDERS'"
                                    >
                                        <v-btn
                                            block
                                            color="ternary"
                                            variant="tonal"
                                            class="rounded-lg mb-4 elevation-0 cursor-pointer"
                                            size="large"
                                        >
                                            <div class="d-flex">
                                                <v-icon icon="$add_to_drive" class="mr-2" />
                                                Google Drive
                                            </div>
                                        </v-btn>
                                    </DropZoneGoogleDrive>
                                </v-col>
                                <v-col
                                    :cols="localGDrive ? 4 : 6"
                                    class="mb-0 pb-0"
                                    v-if="localDBox"
                                >
                                    <DropZoneDropbox
                                        apiKey="av39x7u4hm16p67"
                                        :multiselect="true"
                                        @picked="onDropBoxFilesSelected"
                                    >
                                        <v-btn
                                            block
                                            color="ternary"
                                            variant="tonal"
                                            class="rounded-lg mb-4 elevation-0 cursor-pointer"
                                            size="large"
                                        >
                                            <div class="d-flex">
                                                <v-icon icon="$fa-dropbox" class="mr-2" />
                                                Dropbox
                                            </div>
                                        </v-btn>
                                    </DropZoneDropbox>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" v-if="test">
                            <v-text-field-filled
                                outlined
                                label="Fichier test"
                                v-model="testFileName"
                                data-cy="uploadDocuments-testFile"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12" v-if="autoOpenFileDialog">
                            <input
                                ref="ossOpenFileDialog"
                                type="file"
                                :accept="accept"
                                @update:model-value="onOpenFileDialogChange"
                                v-intersect="openFileDialog"
                                style="color: #fff"
                            />
                        </v-col>
                    </v-row>

                    <!-- <div class="text-center pa-3 rounded-lg" style="max-height: 70vh; border: dashed red;" >
                        <p style="margin-top:35px;font-size:24px">{{$t("documentUpload.dropFile")}}</p>
                        <p style="font-size:20px"><strong>{{$t("documentUpload.advice")}}</strong></p>
                        <label>{{$t("documentUpload.selectFile")}}</label>
                    </div> -->

                    <v-row v-if="formatError">
                        <v-col cols="12">
                            <v-alert type="error">Format de fichier non supporté</v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <div class="d-flex jusitfy-end">
                                {{
                                    $t("shared.amountOfFiles", {
                                        count: fileToUploadCount,
                                    })
                                }}
                            </div>
                        </v-col>
                        <v-col cols="2" v-if="isPossibleToMerge">
                            <v-switch
                                v-if="!isMergingDocument"
                                v-model="isLinkedDocument"
                                @click.stop="linkDocument()"
                            />
                            <v-icon v-else />
                        </v-col>
                        <v-col cols="7" v-if="isPossibleToMerge">
                            <p>Fusionner les images pour créer une facture multi-page</p>
                        </v-col>
                    </v-row>
                    <draggable
                        v-model="files"
                        handle=".handle"
                        :item-key="(file, index) => index"
                        two-line
                        v-if="files.length"
                    >
                        <template #item="{ element: file, index: i }">
                            <v-list-item
                                class="oss-list-item"
                                :key="i"
                                :class="getFileItemClass(file)"
                                ripple
                            >
                                <template #prepend>
                                    <v-skeleton-loader
                                        type="image"
                                        class="my-0 mr-2"
                                        style="height: 40px; width: 40px; overflow: hidden"
                                        v-if="file.loading"
                                    />
                                    <v-img
                                        v-else-if="file.thumb"
                                        :src="file.thumb"
                                        class="my-0 mr-2"
                                        alt="document thumbnail"
                                        width="50"
                                        height="50"
                                    />
                                    <v-icon class="pa-2" v-else>$oss-file</v-icon>
                                </template>
                                <v-list-item-title>
                                    <v-row no-gutters>
                                        <v-col
                                            cols="12"
                                            v-if="
                                                [
                                                    'MISCELLANEOUS',
                                                    'BANK_STATEMENT',
                                                    'COMPANIES',
                                                    'INVOICE_PRODUCTS',
                                                    'STOCK_PRODUCTS',
                                                    'FIXED_ASSETS',
                                                ].includes(documentType) && file.status === 'ok'
                                            "
                                            class="pt-1"
                                        >
                                            <v-text-field
                                                v-model="file.displayName"
                                                outlined
                                                label="Nom du fichier"
                                                hide-details
                                                density="compact"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" v-else>
                                            {{ file.name }}
                                        </v-col>
                                    </v-row>
                                    <v-progress-linear
                                        color="secondary"
                                        height="10"
                                        rounded
                                        v-if="file.active || file.progress !== '0.00'"
                                        :model-value="file.progress"
                                    />
                                </v-list-item-title>
                                <v-list-item-title
                                    v-if="file.status !== 'ok' && file.status !== ''"
                                >
                                    <v-icon class="mr-2">$warning</v-icon>
                                    <strong>{{ $t("documentUpload." + file.status) }}</strong>
                                </v-list-item-title>
                                <template v-else>
                                    <v-list-item-subtitle>{{ file.type }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>{{ file.size }}</v-list-item-subtitle>
                                </template>

                                <template
                                    v-slot:append
                                    class="my-0"
                                    v-show="!uploader.active && !file.success"
                                >
                                    <v-btn-icon
                                        icon="$delete_outline"
                                        @click="onFileRemove(file)"
                                    />
                                </template>
                            </v-list-item>
                        </template>
                    </draggable>
                    <!-- <div v-show="uploader && uploader.dropActive" class="drop-active">
                        <h3>
                            {{
                                multiple
                                    ? $t("documentUpload.dropFiles")
                                    : $t("documentUpload.dropFile")
                            }}
                        </h3>
                    </div> -->
                </v-card-text>
            </v-window-item>
        </v-window>
        <v-card-actions v-if="showActionsBtn">
            <v-btn rounded elevation="0" @click="previousStep()" v-if="showPrevious" size="small">
                Précédent
            </v-btn>
            <v-spacer />
            <v-btn
                rounded
                style="color: #fff"
                class="btn mr-0"
                @click.prevent="nextStepBtnAction()"
                v-if="nextStepBtn"
                size="small"
            >
                Suivant
            </v-btn>
            <template v-else>
                <v-btn
                    rounded
                    style="color: #fff"
                    class="btn mr-0"
                    @click.prevent="nextStep()"
                    v-if="wizardStep >= 1 && wizardStep <= 2"
                    size="small"
                >
                    Suivant
                </v-btn>
                <v-btn
                    size="small"
                    rounded
                    elevation="0"
                    style="color: #fff"
                    class="mr-0"
                    v-show="!uploader || !uploader.active"
                    @click.prevent="startUpload"
                    :disabled="!fileToUploadCount"
                    v-if="wizardStep === 3"
                >
                    {{ $t("action.startUpload") }}
                </v-btn>
                <v-btn
                    rounded
                    color="red"
                    style="color: #fff"
                    class="btn mr-0"
                    elevation="0"
                    loading
                    v-show="uploader && uploader.active"
                    @click.prevent="uploader.active = false"
                    v-if="wizardStep === 3"
                    size="small"
                >
                    Import en cours
                </v-btn>
            </template>
        </v-card-actions>
    </v-card>

    <file-upload
        ref="uploader"
        v-model="files"
        :headers="actionHeaders"
        :extensions="extensions"
        :accept="accept"
        :drop="drop"
        :multiple="multiple"
        :label="'Sélectionnez un tag pour tout les documents'"
        :drop-directory="true"
        @input-filter="inputFilter"
        @input-file="inputFile"
        :custom-action="customAction"
    />
</template>

<script lang="ts">
import crypto from "crypto";
import gql from "graphql-tag";
import VueUploadComponent from "vue-upload-component";
// import DropBox from "@/components/uploads/DropBox.vue";
import moment from "moment-timezone";
import heic2any from "heic2any";
import axios from "axios";
import { User } from "@/store/store";
import { Apollo } from "@/decorators";
import REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY from "../../graphql/accountableAccount/RevenueAccountableAccounts.gql";
import UPLOAD_DROPBOX_DOCUMENT from "../../graphql/document/UploadDropboxDocument.gql";
import UPLOAD_TEST_DOCUMENT from "../../graphql/document/UploadTestDocument.gql";
import TEST_FILE_FIRST from "../../graphql/TestFileFirst.gql";

import { getDBFormattedDate } from "../../services/dateServices";
import { getDBFile } from "../../services/fileServices";
import FreeTag from "../tag/FreeTag.vue";
import SelectUser from "../user/SelectUser.vue";

import { DropZone, DropZoneDropbox, DropZoneGoogleDrive } from "@/components/ui/drop-zone";
import getEnv from "@/env";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { Component, Prop, Ref, toNative, Watch } from "vue-facing-decorator";
import draggable from "vuedraggable";
import { ComponentBase } from "../ComponentBase";
import ossDialogNotificationComp from "../ossComponents/ossDialogNotification.vue";
const suspensePurchaseAccount = "600000";
const suspenseSalesAccount = "700000";
const GDRIVE = "GDRIVE";
const DBOX = "DBOX";
const TEST = "TEST";

const _typeof =
    typeof Symbol === "function" && typeof Symbol.iterator === "symbol"
        ? function (obj) {
              return typeof obj;
          }
        : function (obj) {
              return obj &&
                  typeof Symbol === "function" &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : typeof obj;
          };

const env = getEnv();

// const suspenseGestonSalesAccount = "700G";
/**
 * @param { string } documentType mode de fonctionnement du composant.
 * {
 *      "EXPENSE_REPORT_DOCUMENT": upload des documents pour compléter les notes de frais.
 *      other: fonctionnement par defaut (upload des factures d'achats de ventes. est sélectionné par default si documentType n'est pas renseigné)
 *
 * }
 */

@Component({
    components: {
        fileUpload: VueUploadComponent,
        SelectUser,
        FreeTag,
        draggable,
        ossDialogNotification: ossDialogNotificationComp,
        DropZone,
        DropZoneGoogleDrive,
        DropZoneDropbox,
    },
    emits: ["next", "fileInput", "fileUploaded", "back", "files-uploaded", "new-document"],
})
export class UploadDocuments extends ComponentBase {
    @Prop({ default: "" }) readonly companyId: string;
    @Prop({ default: "" }) readonly documentId: string;
    @Prop({ default: "" }) readonly documentType: string;
    @Prop({ default: "" }) readonly documentStatus: string;
    @Prop({ default: false }) readonly creditNote: boolean;
    @Prop({ default: true }) readonly multiple: boolean;
    @Prop({ default: true }) readonly showFirstPrevious: boolean;
    @Prop({ default: false }) readonly selectTag: boolean;
    @Prop({ default: null }) readonly inExtensions: any;
    @Prop({ default: true }) readonly freeTag: boolean;
    @Prop({ default: true }) readonly gDrive: boolean;
    @Prop({ default: true }) readonly dBox: boolean;
    // @Prop({ default: false }) readonly nextStepBtn: boolean
    @Prop({ default: 20000000 }) readonly maxSize: number;
    @Prop({ default: false }) readonly showActionsBtn: boolean;
    @Prop({ default: false }) hideTitle: boolean;
    @Prop({ default: null }) actions: any;
    @Prop({ default: true }) disableAutoOpenFileDialog: boolean;
    @Prop({ default: false }) auditCheckMode: boolean;
    @Prop({ default: false }) automaticSplit: boolean;
    @Prop({ default: "" }) ownerId: string;

    @Ref("uploader") readonly uploader: any;

    insideDocumentType: string = "";

    wizardStep_: number = 3;

    endProcessed = 0;

    testFileName: string = "";

    isLinkedDocument: boolean = false;

    isMergingDocument: boolean = false;

    mergedDocument: any = {};

    saveFile = [];

    date;

    formatError: boolean = false;

    createdDocIds: string[] = [];

    get acceptedFileTypesWording() {
        return `(formats acceptés : ${this.extensions.join(", ")})`;
    }

    get areSomeFilesUnsupported() {
        return this.files.some((file) => {
            if (!file.type) {
                const ext = file.file.name.split(".");
                const extensionMimeType = this.dicoExtensionsMimeTypes[ext[ext.length - 1]];
                return !extensionMimeType || !this.mimeTypes.find((mt) => mt === extensionMimeType);
            }
            return !this.mimeTypes.find((t) => t === file.type);
        });
    }

    get test(): boolean {
        if (moment().isBefore(moment("2023-12-02"))) {
            return false;
        }
        return env.DEV_MODE;
        // return this.$store.state.test
    }

    get activateTagguing() {
        return this.freeTag;
    }

    get wizardStep() {
        return this.wizardStep_;
    }

    set wizardStep(data) {
        this.wizardStep_ = data;
        this.setActionButton();
    }

    get localGDrive() {
        if (this.$vuetify.display.mobile) return false;
        return this.gDrive;
    }

    get localDBox() {
        if (this.$vuetify.display.mobile) return false;
        return this.dBox;
    }

    /**
     * Get the size of the file upload column
     */
    get fileUploadColSize(): number {
        if (this.localGDrive && this.localDBox) return 4;
        if (this.localGDrive || this.localDBox) return 6;
        return 12;
    }

    startUpload() {
        if (this.uploader) {
            this.uploader.active = true;
        }
    }

    actionDisabled() {
        return false;
    }

    wordingButton() {
        // TODO: FIx the error that arises with $tc in some cases where this.$tc becomes undefined. The try / catch is a temporary escape
        try {
            if (!this.uploader || !this.uploader.active) {
                return "Démarrer";
            }
            return "Arrêter";
        } catch (e) {
            console.error("wordingButton: $tc error", e);
            return "";
        }
    }

    functionButton() {
        if (!this.uploader || !this.uploader.active) {
            this.uploader.active = true;
        } else {
            this.uploader.active = false;
        }
    }

    addToFiles(file: HTMLInputElement) {
        if (this.uploader) {
            this.externalFileInput = true;
            this.autoUpload = true;
            this.uploader.addInputFile(file);
        } else {
            debugger;
        }
    }

    externalFileInput = false;

    activity: any;

    autoUpload = false;

    owner = {
        id: "",
        lastname: "",
        firstname: "",
        email: "",
        company: null,
        profile: null,
        availableCompanies: null,
    };

    get internalOwnerId() {
        return this.owner?.id || this.ownerId || undefined;
    }

    setActionButton() {
        if (this.actions && this.actions.action) {
            if (this.nextStepBtn) {
                this.actions.action.display = true;
                this.actions.action.disabled = false;
                this.actions.action.title = "Suivant";
                this.actions.action.function = this.nextStepBtnAction;
            } else if (this.wizardStep >= 1 && this.wizardStep <= 2) {
                this.actions.action.display = true;
                this.actions.action.disabled = false;
                this.actions.action.title = "Suivant";
                this.actions.action.function = this.nextStep;
            } else if (this.wizardStep === 3) {
                this.actions.action.display = true;
                this.actions.action.disabled = this.actionDisabled;
                this.actions.action.title = this.wordingButton;
                this.actions.action.function = this.functionButton;
            } else if (this.auditCheckMode) {
                this.actions.action.display = true;
                this.actions.action.disabled = false;
                this.actions.action.title = "Valider";
                this.actions.action.function = this.inputFile;
            } else {
                this.actions.action.display = false;
            }
        }
    }

    get isPossibleToMerge() {
        if (this.isLinkedDocument && this.files.length) {
            return true;
        }
        if (this.files.length < 2) {
            return false;
        }
        for (const file of this.files) {
            if (file.type === "application/pdf") {
                return false;
            }
        }
        return true;
    }

    async convertToPng(file: Blob, width_: number, height_: number) {
        return new Promise<{ buffer: string; newWidth: number; newHeight: number }>(
            (resolve, reject) => {
                let width = width_;
                let height = height_;
                if (file.type != "image/heic") {
                    const reader = new FileReader();
                    reader.onloadend = async () => {
                        const data = await this.dataURLtoImage(reader.result.toString());
                        const image = await this.loadImage(data.src);
                        const canva = this.createCanvas(image.width, image.height);
                        const context = canva.getContext("2d");
                        context.drawImage(image, 0, 0);
                        const buffer = canva.toDataURL("image/jpeg");
                        if (width < image.width) {
                            width = image.width;
                        }
                        height += image.height;
                        const returndata = { buffer: buffer, newWidth: width, newHeight: height };
                        resolve(returndata);
                    };

                    reader.onerror = () => {
                        reader.abort();
                        reject(new Error("An error occurred while reading the file."));
                    };
                    reader.readAsDataURL(file);
                } else {
                    heic2any({ blob: file, toType: "image/jpeg" }).then(
                        (conversionResult: Blob) => {
                            const imageUrl = URL.createObjectURL(conversionResult);
                            const image = new Image();
                            image.src = imageUrl;
                            const canva = this.createCanvas(image.width, image.height);
                            const context = canva.getContext("2d");
                            context.drawImage(image, 0, 0);
                            const buffer = canva.toDataURL("image/jpeg");
                            if (width < image.width) {
                                width = image.width;
                            }
                            height += image.height;
                            const returndata = {
                                buffer: buffer,
                                newWidth: width,
                                newHeight: height,
                            };
                            resolve(returndata);
                        },
                    );
                }
            },
        );
    }

    async generateMergedDocument(file: File, mergedBuffer: string) {
        const doc = {
            file: file,
            name: file.name,
            size: file.size,
            type: file.type,
            status: "success",
            fileObject: true,
        };
        if (!this.mergedDocument.size) {
            this.saveFile = [...this.files];
        } else {
            for (let i = 0; i != this.files.length; i += 1) {
                if (this.files.at(i).size != this.mergedDocument.size) {
                    this.saveFile.push(this.files.at(i));
                }
            }
        }
        this.mergedDocument = doc;
        (this.uploader as any).clear();
        (this.uploader as any).add(doc);
    }

    async linkDocument() {
        if (this.isLinkedDocument) {
            this.isMergingDocument = true;
            this.actions.action.disabled = true;

            let width = 0;
            let height = 0;
            const images: string[] = [];

            if (!this.saveFile.length) {
                this.saveFile = [...this.files];
            }

            for (const file of this.saveFile) {
                const data = await this.convertToPng(file.file, width, height);
                images.push(data.buffer);
                width = data.newWidth;
                height = data.newHeight;
            }

            const mergedCanva = this.createCanvas(width, height);
            const mergedContext = mergedCanva.getContext("2d");
            let actualHeight = 0;

            for (const buffer of images) {
                const bufferData = await this.dataURLtoImage(buffer);
                const tmpImage = await this.loadImage(bufferData.src);
                mergedContext.drawImage(tmpImage, 0, actualHeight);
                actualHeight += tmpImage.height;
            }

            const mergedBuffer = mergedCanva.toDataURL("image/jpeg");

            const res: Response = await fetch(mergedBuffer);
            const blob: Blob = await res.blob();
            const file: File = new File([blob], "document.jpg", { type: "image/jpeg" });

            await this.generateMergedDocument(file, mergedBuffer);

            this.isMergingDocument = false;
            this.actions.action.disabled = false;
        } else if (this.mergedDocument.size) {
            this.isMergingDocument = true;
            this.actions.action.disabled = true;

            (this.uploader as any).clear();

            for (const file of this.saveFile) {
                (this.uploader as any).add(file);
            }

            this.mergedDocument = {};
            this.saveFile = [];

            this.isMergingDocument = false;
            this.actions.action.disabled = false;
        }
    }

    @Watch("files")
    updateLinkedDocument() {
        if (!this.files.length) {
            if (this.isLinkedDocument) {
                this.saveFile = [];
                this.isLinkedDocument = false;
            }
        }
    }

    beforeMount() {
        // this.initializeUserActivity()
        if (this.addUser) {
            this.wizardStep = 2;
        } else {
            this.wizardStep = 3;
        }
        this.setActionButton();
    }

    get nextStepBtn() {
        return this.$attrs && this.$attrs.next;
    }

    nextStepBtnAction() {
        this.$emit("next");
    }

    get documentTypes() {
        const ca = this.legalForm !== "EI" ? "CURRENT_ACCOUNT" : "OPERATOR_ACCOUNT";
        if (this.declareSalesInvoices) {
            const types = ["SALES_INVOICE", "PURCHASE_INVOICE", ca, "PAY_SLIP"];
            return types;
        }
        const types = ["PURCHASE_INVOICE", ca, "PAY_SLIP"];
        return types;
    }

    formatType(type) {
        // TODO: FIx the error that arises with $tc in some cases where this.$tc becomes undefined. The try / catch is a temporary escape
        try {
            return this.$t("document.type." + type);
        } catch (e) {
            console.error("formatType: $tc error", e);
            return type;
        }
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get selectedCompany() {
        if (this.companyId) {
            return this.$store.getters.getCompany(this.companyId);
        }
        return null;
    }

    get declareSalesInvoices() {
        if (this.selectedCompany) {
            if (
                this.selectedCompany.incomeCategory === "BNC" &&
                isNotSubjectToVAT(this.selectedCompany.vatSystem)
            )
                return false;
            return true;
        }
        return false;
    }

    get legalForm() {
        return this.selectedCompany?.legalForm || "";
    }

    get workingDocumentType() {
        return this.insideDocumentType || this.documentType;
    }

    set workingDocumentType(value) {
        this.insideDocumentType = value;
    }

    files = [];

    actionHeaders = {
        "x-amz-acl": "private",
    };

    dicoExtensionsMimeTypes = {
        jpeg: "image/jpeg",
        jpg: "image/jpg",
        png: "image/png",
        tiff: "application/tiff",
        tif: "application/tif",
        pdf: "application/pdf",
        doc: "application/msword",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        xls: "application/vnd.ms-excel",
        csv: "text/csv",
        tsv: "text/tsv",
        ofx: "text/ofx",
        txt: "text/plain",

        JPEG: "image/jpeg",
        JPG: "image/jpg",
        PNG: "image/png",
        TIFF: "application/tiff",
        TIF: "application/tif",
        PDF: "application/pdf",
        DOC: "application/msword",
        DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        XLS: "application/vnd.ms-excel",
        CSV: "text/csv",
        TSV: "text/tsv",
        OFX: "text/ofx",
        TXT: "text/plain",
    };

    get extensions() {
        if (this.inExtensions) {
            return this.inExtensions;
        }
        if (this.documentType && this.documentType === "UNKNOWN") {
            return ["pdf"];
        }
        return ["jpeg", "jpg", "png", "tiff", "tif", "pdf"];
    }

    get accept() {
        return this.mimeTypes.join(",");
    }

    get mimeTypes() {
        return this.extensions.map((e) => this.dicoExtensionsMimeTypes[e]);
    }

    get drop() {
        return !this.$vuetify.display.mobile;
    }

    createCanvas(width, height) {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }

    loadImage(src: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const image = new Image();

            function cleanup() {
                image.onload = null;
                image.onerror = null;
            }

            image.onload = () => {
                cleanup();
                resolve(image);
            };
            image.onerror = (err) => {
                cleanup();
                reject(err);
            };

            image.src = src;
        });
    }

    dataURLtoImage(dataURL: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error("dataURLtoImage(): dataURL is illegal"));
            img.src = dataURL;
        });
    }

    async customAction(file, component) {
        if (file.origin) {
            if (file.origin === GDRIVE) {
                file.loading = true;
                // isGoogleDriveDocumentUploaded(data: isGoogleDriveDocumentUploadedInput): isGoogleDriveDocumentUploadedPayLoad
                const res: any = await this.$apollo.mutate({
                    mutation: gql`
                        mutation uploadGoogleDriveDocument(
                            $companyId: ID!
                            $name: String!
                            $contentType: String!
                            $accessToken: String!
                            $gDriveFileId: String!
                        ) {
                            uploadGoogleDriveDocument(
                                data: {
                                    companyId: $companyId
                                    name: $name
                                    accessToken: $accessToken
                                    contentType: $contentType
                                    gDriveFileId: $gDriveFileId
                                }
                            ) {
                                sha256
                                key
                            }
                        }
                    `,
                    variables: {
                        companyId: this.companyId,
                        name: file.name,
                        accessToken: this.googleAccessToken,
                        contentType: file.type,
                        gDriveFileId: file.id,
                    },
                });

                if (res && res.data && res.data.uploadGoogleDriveDocument) {
                    file.sha256 = res.data.uploadGoogleDriveDocument.sha256;
                    file.key = res.data.uploadGoogleDriveDocument.key;
                }
                file.progress = "100.00";
                file.loading = false;

                component.update(file, {
                    active: false,
                    success: true,
                });
                return file;
            } else if (file.origin === DBOX) {
                file.loading = true;
                const res: any = await this.$apollo.mutate({
                    mutation: UPLOAD_DROPBOX_DOCUMENT,

                    variables: {
                        name: file.name,
                        dBoxFileId: file.id,
                        link: file.link,
                        contentType: file.type,
                        companyId: this.companyId,
                    },
                });

                if (res && res.data && res.data.uploadDropboxDocument) {
                    file.sha256 = res.data.uploadDropboxDocument.sha256;
                    file.key = res.data.uploadDropboxDocument.key;
                }

                file.progress = "100.00";
                file.loading = false;

                component.update(file, {
                    active: false,
                    success: true,
                });
                return file;
            } else if (file.origin === TEST) {
                file.loading = true;
                const res: any = await this.$apollo.mutate({
                    mutation: UPLOAD_TEST_DOCUMENT,

                    variables: {
                        name: file.name,
                        fileKey: file.fileKey,
                        contentType: file.type,
                        companyId: this.companyId,
                    },
                });

                if (res && res.data && res.data.uploadTestDocument) {
                    file.sha256 = res.data.uploadTestDocument.sha256;
                    file.key = res.data.uploadTestDocument.key;
                }

                file.progress = "100.00";
                file.loading = false;

                component.update(file, {
                    active: false,
                    success: true,
                });
                return file;
            } else {
                // NOT IMPLEMENTED
                debugger;
            }
        }
        if (file.putAction) {
            if (file.data) {
                // return this.uploadFile(file, component)
                // return this.putUploadHtml5(file, component)
                return component.uploadPut(file);
            } else {
                return this.putUploadHtml5(file, component);
                // return component.uploadPut(file);
            }
        }
        return true;
    }

    putUploadHtml5(file, component) {
        return new Promise((resolve, reject) => {
            return axios({
                method: "PUT",
                url: file.putAction,
                data: file.file, // NOTE - this is the file not the FormData Object
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then((res) => {
                    component.update(file, {
                        progress: "100.00",
                        loading: false,
                        active: false,
                        success: true,
                    });
                    resolve(file);
                })
                .catch((err) => {
                    console.error(err);
                    reject(err);
                });
        });
        // var form = new window.FormData();
        // var value = void 0;
        // for (var key in file.data) {
        //   value = file.data[key];
        //   if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString !== 'function') {
        //     if (value instanceof File) {
        //       form.append(key, value, value.name);
        //     } else {
        //       form.append(key, JSON.stringify(value));
        //     }
        //   } else if (value !== null && value !== undefined) {
        //     form.append(key, value);
        //   }
        // }
        // form.append(component.name, file.file, file.file.filename || file.name);
        // var xhr = new XMLHttpRequest();
        // xhr.open('PUT', file.putAction);
        // return component.uploadXhr(xhr, file, form);
    }

    async getUrl(file: any) {
        if (!file.headers) {
            file.headers = {};
        }
        file.headers["Content-Type"] = file.type;
        file.loading = false;
        file.putAction = "";
        file.key = "";
        //
        if (this.maxSizeReached(file.size)) {
            file.status = "max-size-reached";
            return;
        }

        await getDBFile(this.$apollo, this.companyId, file);

        if (this.autoUpload) {
            this.uploader.active = true;
        }
    }

    get title() {
        if (this.hideTitle) {
            return "";
        }
        if (this.wizardStep === 1) {
            return "Choisissez le type de document à importer";
        }
        if (this.wizardStep === 2) {
            if (this.workingDocumentType === "PAY_SLIP") {
                return "Choisissez l'employé";
            }
            return "Choisissez l'associé";
        }
        if (this.wizardStep === 3) {
            let title = this.creditNote
                ? this.$t("documentUpload.titleCreditNote", this.multiple ? 2 : 1)
                : this.$t("documentUpload.title", this.multiple ? 2 : 1);
            if (this.workingDocumentType === "PURCHASE_INVOICE") {
                title += " d'achat";
            } else if (this.workingDocumentType === "SALES_INVOICE") {
                title += " de vente";
            } else if (this.workingDocumentType === "CURRENT_ACCOUNT") {
                title += " de compte courant";
            } else if (this.workingDocumentType === "OPERATOR_ACCOUNT") {
                title += " de compte d'exploitant";
            } else if (this.workingDocumentType === "EXPENSE_REPORT") {
                title += " de note de frais";
            } else if (this.workingDocumentType === "EXPENSE_REPORT_DOCUMENT") {
                title += " de note de frais";
            } else if (this.workingDocumentType === "MISCELLANEOUS") {
                title = "Choisissez des documents divers";
            } else if (this.workingDocumentType === "PAY_SLIP") {
                title = "Choisissez des fiches de paie";
            } else if (this.workingDocumentType === "BANK_STATEMENT") {
                title = "Choisissez des relevés de banques (pdf)";
            } else if (this.workingDocumentType === "COMPANIES") {
                title += " de sociétés";
            } else if (this.workingDocumentType.includes("PRODUCTS")) {
                title += " de produits";
            } else if (this.workingDocumentType === "FIXED_ASSETS") {
                title += " d'immobilisations ou d'amortissements";
            }
            return title;
        }
        return "";
    }

    async getSuspenseAccount() {
        if (this.workingDocumentType === "PURCHASE_INVOICE") {
            return suspensePurchaseAccount;
        }

        if (this.workingDocumentType === "SALES_INVOICE") {
            if (this.companyId) {
                const result = await this.$apollo.query({
                    query: REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY,
                    variables: {
                        companyId: this.companyId,
                        vatRate0: false,
                    },
                });
                // debugger
                if (
                    result &&
                    result.data &&
                    result.data.companySalesAccounts &&
                    result.data.companySalesAccounts.salesAccounts &&
                    result.data.companySalesAccounts.salesAccounts.length === 1
                ) {
                    return result.data.companySalesAccounts.salesAccounts[0].name;
                }
            }
            return suspenseSalesAccount;
        }
        if (
            this.workingDocumentType === "CURRENT_ACCOUNT" ||
            this.workingDocumentType === "OPERATOR_ACCOUNT"
        ) {
            return suspensePurchaseAccount;
        }
        if (this.workingDocumentType === "EXPENSE_REPORT") {
            return suspensePurchaseAccount;
        }
        if (this.workingDocumentType === "PAY_SLIP") {
            return undefined;
        }
        return undefined;
    }

    get fileToUploadCount() {
        let count = 0;
        if (this.files) {
            for (const file of this.files) {
                count++;
            }
        }
        return count;
    }

    async onTags(data) {
        this.toAddTags.push(...data.toAddTags);
        this.toCreateTags.push(...data.toCreateTags);
    }

    toAddTags = [];
    toCreateTags = [];

    //
    // from google drive
    //
    async onGoogleDriveFilesSelected(data) {
        if (data?.docs?.length) {
            // isGoogleDriveDocumentUploaded(data: isGoogleDriveDocumentUploadedInput): isGoogleDriveDocumentUploadedPayLoad
            const res: any = await this.$apollo.query({
                query: gql`
                    query files($companyId: ID!, $gDriveFileIds: [String!]) {
                        documents(
                            companyId: $companyId
                            where: { company: { id: $companyId }, importId_in: $gDriveFileIds }
                        ) {
                            id
                            importId
                        }
                    }
                `,
                fetchPolicy: "network-only",
                variables: {
                    gDriveFileIds: data.docs.map((d) => GDRIVE + "_" + d.id),
                    companyId: this.companyId,
                },
            });
            let uploadedDocuments = [];
            if (res?.data?.documents) {
                uploadedDocuments = res.data.documents;
            }
            for (const doc of data.docs) {
                doc.fileObject = true;
                doc.size = doc.sizeBytes;
                doc.type = doc.mimeType;
                doc.origin = GDRIVE;
                doc.status = uploadedDocuments.find((ud) => ud.importId === GDRIVE + "_" + doc.id)
                    ? "already-uploaded"
                    : "ok";
                if (doc.status === "ok" && this.maxSizeReached(doc.size)) {
                    doc.status = "max-size-reached";
                }
                (this.uploader as any).add(doc);
            }
        }
    }

    maxSizeReached(size) {
        if (
            this.workingDocumentType !== "MISCELLANEOUS" &&
            this.maxSize > 0 &&
            size > this.maxSize
        ) {
            return true;
        }
        return false;
    }

    //
    // from dropbox
    //
    async onDropBoxFilesSelected(uploadedDropbox: any) {
        for (const doc of uploadedDropbox) {
            doc.fileObject = true;
            doc.id = doc._id;
            doc.name = doc.title;
            // doc.link = doc.link
            doc.type = doc.extension;
            doc.origin = DBOX;
            doc.status = uploadedDropbox.find((ud) => ud.importId === DBOX + "_" + doc.id)
                ? "already-uploaded"
                : "ok";
            if (doc.status === "ok" && this.maxSizeReached(doc.size)) {
                doc.status = "max-size-reached";
            }
            (this.uploader as any).add(doc);
        }

        this.linkDocument();
    }

    //
    // from device
    //

    onFileRemove(file) {
        this.uploader.remove(file);
        if (!this.areSomeFilesUnsupported) {
            if (this.actions) {
                this.actions.action.disabled = false;
            }
            this.formatError = false;
        }
    }

    async inputFile(newFile, oldFile) {
        if (this.areSomeFilesUnsupported) {
            this.formatError = true;
            if (this.actions) {
                this.actions.action.disabled = true;
            }
            return;
        }
        if (this.externalFileInput) {
            this.inputFilter(newFile, null, null);
        }

        if (newFile && !oldFile) {
            // debugger
            this.$emit("fileInput", newFile);
        } else if (newFile && oldFile) {
            // debugger;
            //
            // update file
            //
            if (newFile.progress !== oldFile.progress) {
                console.log("progress");
            }
            if (newFile.error && !oldFile.error) {
                console.error("error while uploading", newFile.error);
            }
            if (newFile.success !== oldFile.success) {
                // debugger;
                // if (newFile.success && !oldFile.success) {
                if (newFile.status === "already-uploaded") {
                    return;
                } else if (!newFile.key) {
                    newFile.status = "upload-failed";
                    return;
                }
                console.log("successfully uploaded");

                // newFile.url = newFile.putAction || "";
                let res;
                if (this.auditCheckMode) {
                    let ext = newFile.name.split(".");
                    if (ext.length) {
                        ext = ext[ext.length - 1].toUpperCase();
                    }
                    res = await this.$apollo.mutate({
                        mutation: gql`
                            mutation createDocumentWithFile(
                                $name: String!
                                $fileType: FileType!
                                $fileKey: String!
                                $sha256: String
                                $size: Float!
                                $companyId: ID!
                                $ownerId: ID
                                $type: DocumentType!
                                $status: DocumentStatus
                                $tags: Json
                                $importId: String
                                $creditNote: Boolean
                                $automaticSplit: Boolean!
                                $date: DateTime
                            ) {
                                createDocumentWithFile(
                                    data: {
                                        name: $name
                                        fileKey: $fileKey
                                        fileType: $fileType
                                        sha256: $sha256
                                        size: $size
                                        ownerId: $ownerId
                                        companyId: $companyId
                                        type: $type
                                        status: $status
                                        tags: $tags
                                        importId: $importId
                                        creditNote: $creditNote
                                        automaticSplit: $automaticSplit
                                        date: $date
                                    }
                                ) {
                                    id
                                    signedUrl
                                    status
                                }
                            }
                        `,
                        variables: {
                            name: newFile.name || newFile.displayName,
                            fileKey: newFile.key,
                            fileType: ext,
                            sha256: newFile.sha256 || undefined,
                            size: newFile.size,
                            companyId: this.companyId,
                            type: this.workingDocumentType,
                            automaticSplit: this.automaticSplit,
                            status: this.documentStatus || undefined,
                            tags: {
                                toAddTags: this.toAddTags,
                                toCreateTags: this.toCreateTags,
                            },
                            importId: newFile.origin ? GDRIVE + "_" + newFile.id : undefined,
                            creditNote: this.creditNote,
                            date: getDBFormattedDate(this.date),
                            ownerId: this.internalOwnerId,
                        },
                    });
                    this.createdDocIds.push(res.data.createDocumentWithFile.id);
                    this.endProcessed++;
                    return;
                }
                // ---------------
                // ZTILL_RECEIPT -
                // ---------------
                else if (
                    this.documentType === "ZTILL_RECEIPT" ||
                    this.documentType === "BOOKLET_TEMPLATE" ||
                    this.documentType === "EXPORT_OFFICE"
                ) {
                    //! besoin de séparer les 2 ? enlever le name du ztill
                    this.$emit("file", {
                        file: {
                            fileKey: newFile.key,
                            name: newFile.name,
                            fileType: newFile.type
                                .substr(newFile.type.lastIndexOf("/") + 1)
                                .toUpperCase(),
                            sha256: newFile.sha256 || undefined,
                            size: newFile.size,
                        },
                        tags: {
                            toAddTags: this.toAddTags,
                            toCreateTags: this.toCreateTags,
                        },
                    });
                    return;
                }
                // -----------------------------------
                // upload file for existing document -
                // --------------------------------- -
                if (this.documentId) {
                    res = await this.$apollo.mutate({
                        mutation: gql`
                            mutation updateDocumentOriginalFile(
                                $documentId: String!
                                $fileType: FileType!
                                $fileKey: String!
                                $sha256: String
                                $size: Float!
                            ) {
                                updateDocumentOriginalFile(
                                    data: {
                                        documentId: $documentId
                                        fileKey: $fileKey
                                        fileType: $fileType
                                        sha256: $sha256
                                        size: $size
                                    }
                                ) {
                                    id
                                    signedUrl
                                }
                            }
                        `,
                        variables: {
                            documentId: this.documentId,
                            fileKey: newFile.key,
                            fileType: newFile.type
                                .substr(newFile.type.lastIndexOf("/") + 1)
                                .toUpperCase(),
                            sha256: newFile.sha256 || undefined,
                            size: newFile.size,
                        },
                    });
                    this.$emit("fileUploaded");
                }
                // -----------------------------------------------
                // new document excepted EXPENSE_REPORT_DOCUMENT -
                // -----------------------------------------------
                else if (this.workingDocumentType !== "EXPENSE_REPORT_DOCUMENT") {
                    let docName = newFile.name || newFile.displayName;
                    let ext = newFile.name.split(".");
                    if (ext.length) {
                        ext = ext[ext.length - 1].toUpperCase();
                    }
                    if (this.workingDocumentType === "PAY_SLIP") {
                        docName = "OD de paie " + this.owner.firstname + " " + this.owner.lastname;
                    }
                    if (
                        this.documentType === "MISCELLANEOUS" ||
                        this.documentType === "BANK_STATEMENT" ||
                        this.documentType === "COMPANIES" ||
                        this.documentType === "PRODUCTS" ||
                        this.documentType === "FIXED_ASSETS"
                    ) {
                        docName = newFile.displayName;
                    }
                    const accountableAccount = await this.getSuspenseAccount();
                    res = await this.$apollo.mutate({
                        mutation: gql`
                            mutation createDocumentWithFile(
                                $name: String!
                                $fileType: FileType!
                                $fileKey: String!
                                $sha256: String
                                $size: Float!
                                $companyId: ID!
                                $ownerId: ID
                                $type: DocumentType!
                                $status: DocumentStatus
                                $accountableAccount: String
                                $tags: Json
                                $importId: String
                                $creditNote: Boolean
                                $automaticSplit: Boolean!
                                $date: DateTime
                            ) {
                                createDocumentWithFile(
                                    data: {
                                        name: $name
                                        fileKey: $fileKey
                                        fileType: $fileType
                                        sha256: $sha256
                                        size: $size
                                        ownerId: $ownerId
                                        companyId: $companyId
                                        type: $type
                                        status: $status
                                        accountableAccount: $accountableAccount
                                        tags: $tags
                                        importId: $importId
                                        creditNote: $creditNote
                                        automaticSplit: $automaticSplit
                                        date: $date
                                    }
                                ) {
                                    id
                                    signedUrl
                                    status
                                }
                            }
                        `,
                        variables: {
                            name: docName,
                            fileKey: newFile.key,
                            // fileType: this.workingDocumentType === "BANK_STATEMENT" ? "CSV" : newFile.type.substr(newFile.type.lastIndexOf("/") + 1).toUpperCase(),
                            fileType:
                                newFile.type
                                    .substr(newFile.type.lastIndexOf("/") + 1)
                                    .toUpperCase() || ext,
                            // url: newFile.url,
                            sha256: newFile.sha256 || undefined,
                            size: newFile.size,
                            companyId: this.companyId,
                            type: this.workingDocumentType,
                            automaticSplit: this.automaticSplit,
                            status: this.documentStatus || undefined,
                            accountableAccount: accountableAccount,
                            tags: {
                                toAddTags: this.toAddTags,
                                toCreateTags: this.toCreateTags,
                            },
                            importId: newFile.origin ? GDRIVE + "_" + newFile.id : undefined,
                            creditNote: this.creditNote,
                            date: getDBFormattedDate(this.date),
                            ownerId: this.internalOwnerId,
                        },
                    });
                    this.$emit("fileUploaded");
                } else {
                    res = await this.$apollo.mutate({
                        mutation: gql`
                            mutation createDocumentWithFile(
                                $name: String!
                                $fileType: FileType!
                                $fileKey: String!
                                $sha256: String
                                $size: Float!
                                $companyId: ID!
                                $ownerId: ID
                                $accountableAccount: String
                                $status: DocumentStatus
                            ) {
                                createDocumentWithFile(
                                    data: {
                                        name: $name
                                        fileKey: $fileKey
                                        fileType: $fileType
                                        sha256: $sha256
                                        size: $size
                                        ownerId: $ownerId
                                        companyId: $companyId
                                        type: EXPENSE_REPORT_DOCUMENT
                                        status: $status
                                        accountableAccount: $accountableAccount
                                        automaticSplit: false
                                    }
                                ) {
                                    id
                                    signedUrl
                                    status
                                }
                            }
                        `,
                        variables: {
                            name: newFile.name,
                            fileKey: newFile.key,
                            fileType: newFile.type
                                .substr(newFile.type.lastIndexOf("/") + 1)
                                .toUpperCase(),
                            // url: newFile.url,
                            sha256: newFile.sha256 || undefined,
                            size: newFile.size,
                            accountableAccount: suspensePurchaseAccount,
                            companyId: this.companyId,
                            ownerId: this.internalOwnerId,
                            status: this.documentStatus || undefined,
                        },
                    });
                }
                if (!this.documentId) {
                    if (res) {
                        console.log("createDocumentWithFile");
                        this.$emit("new-document", {
                            id: res.data.createDocumentWithFile.id,
                            signedUrl: res.data.createDocumentWithFile.signedUrl,
                            status: this.documentStatus || "ORIGINAL_UPLOADED",
                            dueDate: "",
                            grossAmount: "",
                            accountableAccount: {
                                name: "",
                            },
                        });
                    } else {
                        console.error("createDocumentWithFile failed=");
                        debugger;
                    }
                    // setTimeout(() => {
                    // let isEmpty = true
                    // newFile.uploaded = true;
                    // console.log("this.files.length= " + this.files.length)
                    // for (const file of this.files) {
                    //     if (file.status === "ok" && (!file.success || file.success === false)) {
                    //         isEmpty = false
                    //         break;
                    //     }
                    // }
                    // if (isEmpty) {
                    this.endProcessed++;
                    // }
                    // this.createUserActivity(res.data.createDocumentWithFile.id, undefined)
                } else {
                    // this.createUserActivity(this.documentId, "UPDATE")
                }
            }
        } else if (!newFile && oldFile) {
            console.log("remove file oldFile= " + oldFile.file.name);
        }
    }

    @Watch("active")
    onActiveChanged(active) {
        if (active && this.$vuetify && this.$vuetify.display.mobile) {
            // debugger;
            const id = setInterval(() => {
                const element = document.getElementById("uploaderInput");
                if (element) {
                    element.click();
                    clearInterval(id);
                }
            }, 100);
        }
    }

    inputFilter(newFile, oldFile, prevent) {
        // add new file
        if (newFile && !oldFile) {
            // prevent system file
            if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                return prevent();
            }
            // prevent php,js,jsx file
            if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                return prevent();
            }
        }
        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
            // create blob
            newFile.displayName = "";
            if (
                this.documentType === "MISCELLANEOUS" ||
                this.documentType === "BANK_STATEMENT" ||
                this.documentType === "COMPANIES" ||
                this.documentType === "PRODUCTS" ||
                this.documentType === "FIXED_ASSETS"
            ) {
                newFile.displayName = newFile.name;
                const index = newFile.name.lastIndexOf(".");
                if (index !== -1) {
                    newFile.displayName = newFile.name.substring(0, index);
                }
            }
            if (oldFile !== null) {
                // hack to avoid to be called twice
                if (!newFile.origin) {
                    newFile.status = "";
                    // newFile.workingDocumentType = "PURCHASE_INVOICE"
                    // debugger
                    newFile.loading = true;

                    // thumbnail
                    newFile.thumb = "";
                    if (newFile.type.substr(0, 6) === "image/") {
                        const URL = window.URL || window.webkitURL;
                        if (URL && URL.createObjectURL) {
                            newFile.thumb = URL.createObjectURL(newFile.file);
                        }
                    }

                    const reader = new FileReader();
                    reader.onloadend = async () => {
                        // Encode la donnée e base64Url en base64

                        const dataEncrypted = reader.result
                            .toString()
                            .replaceAll(/data:.*;base64,/g, "")
                            .replace(/\+/g, "-")
                            .replace(/\//g, "_");

                        // Génère un buffer

                        const data = Buffer.from(dataEncrypted.toString(), "base64");

                        // Décode le buffer

                        const decoder = new TextDecoder();
                        const string = decoder.decode(data);

                        // Créer la clef de hash

                        newFile.sha256 = crypto.createHash("sha256").update(string).digest("hex");
   
                        await this.getUrl(newFile);
                    };
                    reader.readAsDataURL(newFile.file);

                    // const reader2 = new FileReader();
                    // reader2.onloadend = async (event) => {
                    //     const data = event.target.result;

                    //     console.log("readAsArrayBuffer")
                    //     console.log(data)
                    //     newFile.sha256 = SHA256(data.toString()).toString();
                    //     console.log('encrypted from readAsArrayBuffer: ' + newFile.sha256);
                    //     await this.getUrl(newFile)
                    // };
                    // reader2.readAsArrayBuffer(newFile.file);
                }
            }
        }
        if (this.isLinkedDocument && newFile.size != this.mergedDocument.size) {
            this.linkDocument();
        }
        return true;
    }

    getFileItemClass(file) {
        let fileItemClass = "oss-list-item-inactive mb-2";
        fileItemClass += !this.$vuetify.display.mobile ? " py-2" : " pa-2";
        let status;
        fileItemClass += file.status !== "ok" && file.status !== "" ? " oss-list-item-ko" : "";
        return fileItemClass;
    }

    get addUser() {
        return (
            this.workingDocumentType === "CURRENT_ACCOUNT" ||
            this.workingDocumentType === "OPERATOR_ACCOUNT" ||
            this.workingDocumentType === "PAY_SLIP"
        );
    }

    //
    // wizard
    //
    get showPrevious() {
        if (this.showFirstPrevious) return true;
        if (this.wizardStep === 1) return false;
        if (this.wizardStep === 2) return false;
        if (this.wizardStep === 3 && !this.addUser) return false;
        return true;
    }

    nextStep() {
        if (this.wizardStep === 1) {
            if (this.addUser) {
                this.wizardStep = 2;
            } else {
                this.wizardStep = 3;
            }
        } else if (this.wizardStep === 2) {
            this.wizardStep = 3;
        } else if (this.wizardStep === 3) {
            // debugger;
        }
    }

    previousStep() {
        if (this.wizardStep === 1) {
            this.$emit("back");
            return;
        }
        if (this.wizardStep === 2) {
            this.$emit("back");
        } else if (this.wizardStep === 3) {
            if (this.addUser) {
                this.wizardStep = 2;
            } else {
                this.$emit("back");
            }
        }
    }

    onOwnerSelected(data) {
        this.owner = data;
    }

    getDocumentClass(documentType) {
        let docClass = "mb-2 oss-list-item";
        if (this.$vuetify.display.mobile) {
            docClass += " px-2";
        }
        if (documentType === this.workingDocumentType) {
            docClass += " oss-list-item-selected";
        }
        return docClass;
    }

    googleAccessToken = "";

    onAuthenticated(token) {
        console.log("oauth token:", token);
        this.googleAccessToken = token;
    }

    get autoOpenFileDialog() {
        return this.$vuetify.display.mobile && !this.disableAutoOpenFileDialog;
    }

    @Ref("ossOpenFileDialog") ossOpenFileDialog!: HTMLInputElement;
    openFileDialog(_: any, _entries: any, _observer: any) {
        if (this.$vuetify.display.mobile && this.ossOpenFileDialog) {
            this.ossOpenFileDialog.click();
        }
    }

    onOpenFileDialogChange() {
        const file = this.$refs.ossOpenFileDialog;
        this.addToFiles(file);
    }
    //
    // test file
    //

    @Apollo({
        query() {
            return TEST_FILE_FIRST;
        },
        variables() {
            return {
                name: this.testFileName,
            };
        },
        skip() {
            return !this.testFileName;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.testFileFirst) {
                    this.testFile = data.testFileFirst;

                    const doc = {
                        fileObject: true,
                        id: this.testFileName,
                        name: this.testFileName + "." + this.testFile.type.toLowerCase(),
                        type: this.dicoExtensionsMimeTypes[this.testFile.type],
                        origin: TEST,
                        status: "ok",
                        fileKey: this.testFile.key,
                    };
                    this.uploader.add(doc);
                } else {
                    this.testFile = null;
                }
                this.$emit("testFileInput", this.testFile);
            }
        },
    })
    testFile: any = null;

    @Watch("endProcessed")
    checkEndProcessed() {
        if (this.files.every((f) => f.status === "ok" && f.success === true)) {
            this.files = [];
            setTimeout(() => {
                this.$emit("files-uploaded", { createdDocIds: this.createdDocIds });
                this.createdDocIds = [];
            }, 300);
        }
    }

    onDropFile(files) {
        for (const file of files) {
            this.uploader.add({
                file: file,
                name: file.name,
                size: file.size,
                type: file.type,
                status: "ok",
                fileObject: true,
            });
        }
    }
}

export default toNative(UploadDocuments);
</script>
<style lang="scss" scoped>
.theme--light.v-table thead th {
    font-size: 14px;
}

table.v-table tbody td {
    font-size: 15px;
}

.v-card__title {
    font-size: 20px;
}

.drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: 0.6;
    text-align: center;
    background: #000;
}

.drop-active h3 {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    font-size: 40px;
    color: #fff;
}

.dashed {
    // background-color: #ECECEC;
    // border: 3px dashed #989898;
    // border-radius: 20px;
    background-color: #e1e3eb;
    // background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23989898FF' stroke-width='4' stroke-dasharray='15' stroke-dashoffset='6' stroke-linecap='butt'/%3e%3c/svg%3e");
    border-radius: 8px;
}

::-webkit-file-upload-button {
    border-width: 0px;
    border: none;
    background: transparent;
    color: transparent;
}
</style>
